module.exports = __webpack_public_path__ + "img/team-img3.2585a064.jpg";